/**
 * Search filters Algolia widgets.
 *
 * @param {string} attributeName The name of the Algolia filter.
 * @param {string} containerId The id of the widget container.
 * @param {string} label The default select option text.
 * @returns {object} The Algolia widget.
 */
export default function algoliaFilter (attributeName, containerId, label) {
  return window.instantsearch.widgets.menuSelect({
    container: `.js-search-filter-${containerId}`,
    attributeName,
    autoHideContainer: false,
    limit: 1000,
    templates: {
      seeAllOption: label,
      item: '{{label}}'
    }
  })
}
